import React from 'react';
import { testimonials } from '../data/teknik';
export function Testimonials() {
  // Hidden until authentic TEKNIKKLAR reviews exist (no buyers yet)
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-286" data-mp="3fyvy6aic1db3">
      <div className="mx-auto max-w-6xl" data-id="element-287" data-mp="3b1cjxalmx0j5">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-288" data-mp="3ayi09lag3jqs">
          Vad <em className="text-red-700" data-id="element-289" data-mp="36wmp7p2pprzt">lärarna</em> säger
        </h2>
        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-290" data-mp="31ybfdecf3hhl">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-291" data-mp="2x2w3ut1vtxoc">
              <blockquote className="flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-292" data-mp="2s307nfzffajc">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-293" data-mp="qalipwygt5tf">
                <span className="font-semibold text-slate-900" data-id="element-294" data-mp="qav8pkjifcz4">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-295" data-mp="h4wsxwwqs2fk"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}